var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-content"},[_c('div',{staticClass:"title-font title-description"},[_vm._v(_vm._s(_vm.title.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }